import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Tabs } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import BreadcrumbContainer from '../common/breadcrumbContainer/breadcrumbContainer';

import FormsSearch from './FormsSearch';
import BoardsSearch from './BoardsSearch';
import SearchSelector from './SearchSelector';

import { getQueries, clearSelectedQuery } from './state/search.actions';

const { TabPane } = Tabs;

const DEFAULT_CRUMBS = [{ text: 'Search', icon: 'search' }];

export default function Search({
  history,
}) {
  const dispatch = useDispatch();
  const { paidFlags = [], settings = {} } = useSelector((state) => state.settings.company);
  const isAdvancedSearch = paidFlags.includes('ADVANCED_SEARCH');
  const hasRedesign = settings?.uxRedesignPt1;

  const [activeTab, setActiveTab] = useState('forms');

  const onTabChanged = useCallback((newTab) => {
    setActiveTab(newTab);
    dispatch(clearSelectedQuery());
  }, []);

  const crumbs = useMemo(() => (
    DEFAULT_CRUMBS.concat({
      text: <SearchSelector onTabChanged={setActiveTab} />,
    })
  ), []);

  useEffect(() => {
    dispatch(getQueries('forms'));
    dispatch(getQueries('boards'));
  }, []);

  if (paidFlags?.length && !isAdvancedSearch) {
    history.replace('/dashboard');
    return null;
  }

  return (
    <BreadcrumbContainer crumbs={crumbs} redesignCrumbStyle={{ marginLeft: 5 }}>
      <Tabs
        onChange={onTabChanged}
        activeKey={activeTab}
        tabPosition="left"
        style={{
          position: 'absolute',
          top: hasRedesign ? 130 : 90,
          right: 30,
          bottom: 23,
          left: 20,
        }}
        tabBarStyle={{
          width: 110,
        }}
      >
        <TabPane
          tab={<span>Forms</span>}
          key="forms"
          className="form-tab-pane"
        >
          <FormsSearch />
        </TabPane>
        <TabPane
          tab={<span>Boards</span>}
          key="boards"
          className="form-tab-pane"
        >
          <BoardsSearch />
        </TabPane>
      </Tabs>
    </BreadcrumbContainer>
  );
}

Search.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};
